<template>
  <div>
       <el-form :model="form" ref="form" :label-width="formLabelWidth" :rules="rules">
        <el-form-item label="工号"  prop="tno">
          <el-input v-model="form.tno" placeholder="请输入工号" clearable :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码"  v-if="!isEdit">
          <el-input v-model="form.password" placeholder="请输入密码" clearable></el-input>
        </el-form-item>         
        <el-form-item label="性别"  prop="sex">
          <el-select v-model="form.sex" placeholder="请选择性别" clearable style="width:100%;">
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="form.phone" placeholder="请输入手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱">
          <el-input v-model="form.email" placeholder="请输入电子邮箱" clearable></el-input>
        </el-form-item>        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
  </div>
</template>

<script>
import { updateTeacher, addTeacher} from '@/api/teacher'
import CommonUtil from "@utils/common-util"

export default {
  inject: ['reload'],
  name: "teacherForm",
   props: {
    form: Object,
    isEdit:Boolean
  },  
  data() {
    return {
      rules: {
        tno: [{ required: true, message: '请填写工号', trigger: 'blur' }],
        name: [{ required: true, message: '请填写教师姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
      },
      formLabelWidth: '120px',
    }
  },

  methods: {
    //提交信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return
        }
        CommonUtil.submitForm(this.isEdit, this.form, addTeacher, updateTeacher, this.afterSubmit)
      })
    },
    afterSubmit() {
       this.$emit("afterSubmit");
    },
  }
}
</script>

